export default __webpack_public_path__ + "3af6ad7991b6699e3c9d32230a3657aa.jpg";